


















































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";
import OnscreenMenu from "../general/OnscreenMenu.vue";
import MailingsListDetails from "./MailingsListDetails.vue";

import MailingListJson from "../../shared/MailingListJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

import GeneralInfos from "../custom/GeneralInfos";

export default Vue.extend({
  name: "MailingsListSelect",
  components: {
    OverlayWindow,
    Loading,
    OnscreenMenu,
    TableView,
    MailingsListDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      GeneralInfos: GeneralInfos,
      allMailingLists: [] as MailingListJson[] | null,
      showDetails: false,
      detailsMode: "read",
      selectedMailingListId: null as number | null,
      loadingGeneral: false,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    loadData() {
      this.loadMailingLists();
    },

    async loadMailingLists() {
      this.allMailingLists = null;
      this.selectedMailingListId = null;

      if (this.restClient != null) {
        try {
          this.allMailingLists = await this.restClient.getMailingLists();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async reloadData() {
      this.loadMailingLists();
    },

    closeDetails() {
      this.$emit("closeOverlay");
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "selectItem") {
        this.$emit("selectList", item);
        this.closeDetails();
      }
    },

    tableViewItemClicked(item: any) {
      this.$emit("selectList", item);
      this.closeDetails();
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    mailingListColumns: function (): TableViewColumnDefinitions<MailingListJson>[] {
      return [
        {
          th: "Name",
          td: (i) => i.name,
        },
        {
          th: "Öffentliche Anmeldung",
          td: (i) => (i.isSignUpPublic ? "Ja" : "Nein"),
        },
        {
          th: "",
          td: (i) => "Auswählen",
          style: (i) => "text-align:right",
          button: "selectItem",
        },
      ] as TableViewColumnDefinitions<MailingListJson>[];
    },
  },
});
